import styled from "styled-components";
import Button from "./Button";
import { useCallback, useEffect, useRef, useState } from "react";
import Menu, { TOption } from "./Menu";
import { ROUTES } from "../../../router";
import {
  getQuerystringParams,
  handleGetDataFromLocalStorage,
} from "../../../utils/miscellaneous";
import { useTypedDispatch } from "../../../hooks/useTypedDispatch";
import { setLogoutModalState } from "../../../redux/reducers/globalState";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { useNavigationManager } from "../../../hooks/useNavigationManager";
import { fetchAccounts } from "../../../redux/actions";
import axios from "axios";
import { localStorageConstants } from "../../../utils/constants";

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

type TDropdownUserProps = {
  name: string;
  email: string;
  icon: string;
};

const DropdownUser: React.FC<TDropdownUserProps> = ({ name, email, icon }) => {
  const dispatch = useTypedDispatch();

  const selectedOrganization = useTypedSelector(
    (state) => state.organizations.selectedOrganization
  );

  const accountsData = useTypedSelector((state) => state.account.data);

  const cancelTokenSource = useRef(axios.CancelToken.source());

  const querystring = getQuerystringParams();

  const componentRef = useRef<HTMLDivElement | null>(null);

  const [accountsCount, setAccountsCount] = useState<number | null>(null);

  const [shouldShow, setShouldShow] = useState<"show" | "hide">("hide");

  const [dropDownUserOptions, setDropdownUserOptions] = useState<TOption[]>([
    "id",
    "config",
    "logout",
  ]);
  const { goTo } = useNavigationManager();

  const handleRenderDropdown = useCallback(() => {
    const handleOnClickButton = () => {
      setShouldShow((prev) => (prev === "hide" ? "show" : "hide"));
    };

    const handleOnBlur = () => {
      setShouldShow("hide");
    };

    const handleOnClickMenu = (
      index: string,
      _selected: string[],
      setSelected: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      const value = dropDownUserOptions[parseInt(index)];

      switch (value) {
        case "id":
          window.open("https://id.nexaas.com/", "_blank");
          break;
        case "config":
          querystring.page = 1;
          goTo(ROUTES.SETTINGS, querystring);
          break;
        case "swap":
          querystring.page = 1;
          goTo(ROUTES.ACCOUNTS, querystring);
          break;
        case "logout":
          querystring.page = 1;
          dispatch(setLogoutModalState({ shouldShow: true }));
          break;
      }
      handleOnBlur();
      setSelected([index]);
    };

    return (
      <Container key={accountsData.count} ref={componentRef}>
        <Button
          onBlur={handleOnBlur}
          onClick={handleOnClickButton}
          name={name}
          email={email}
          icon={icon}
          componentRef={componentRef}
        />
        <Menu
          accountsCount={accountsCount ?? 0}
          shouldShow={shouldShow}
          options={dropDownUserOptions}
          onClick={handleOnClickMenu}
        />
      </Container>
    );
  }, [shouldShow, name, accountsData.count]);

  useEffect(() => {
    setTimeout(() => {
      if (
        selectedOrganization &&
        selectedOrganization.permissions &&
        !selectedOrganization.permissions?.organization_management &&
        !selectedOrganization.permissions?.user_management
      ) {
        setDropdownUserOptions((prev) => {
          if (prev.includes("config")) prev.splice(1, 1);
          return [...prev];
        });
      }
    }, 500);
  }, [selectedOrganization]);

  useEffect(() => {
    setTimeout(() => {
      const localAccountCount = handleGetDataFromLocalStorage(
        localStorageConstants.ACCOUNTS_COUNT
      ) as number;

      if (localAccountCount > 1) {
        setDropdownUserOptions(["id", /* "config", */ "swap", "logout"]);

        setAccountsCount(accountsData.count);
      }
    }, 1000);
  }, [accountsData]);

  useEffect(() => {
    dispatch(
      fetchAccounts({ cancelToken: cancelTokenSource.current.token })
    ).unwrap();

    return () => {
      cancelTokenSource.current.cancel(
        "Component unmounted, request cancelled."
      );
    };
  }, []);

  return handleRenderDropdown();
};

export default DropdownUser;
